<script>
    import CenterNavigationMenu from "@/components/CenterNavigationMenu";
    import PersonalNavigationMenu from "@/components/PersonalNavigationMenu";
    import TheLogo from "@/components/TheLogo";
    import HeaderCart from "@zavtra/components/HeaderCart";

    export default {
        name: "TheHeaderMain",
        components: {
            CenterNavigationMenu,
            PersonalNavigationMenu,
            HeaderCart,
            TheLogo,
        },
        props: {
            centerMenu: Array,
            cart: Object,
            freeDeliveryCount: Number,
            isOrderPage: Boolean,
        },
    };
</script>

<template>
    <div class="the-header-main">
        <div class="l-container">
            <div class="the-header-main__wrapper">
                <div class="the-header-main__logo">
                    <the-logo></the-logo>
                </div>

                <div class="the-header-main__navigation">
                    <center-navigation-menu :menu="centerMenu"></center-navigation-menu>
                </div>

                <div class="the-header-main__profile">
                    <personal-navigation-menu></personal-navigation-menu>
                </div>

                <div class="the-header-main__cart">
                    <header-cart
                        :cart="cart"
                        :free-delivery-count="freeDeliveryCount"
                        :is-order-page="isOrderPage"
                    ></header-cart>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .the-header-main {
        display: none;
        @include bp($bp-desktop-sm) {
            @include sticky();
            z-index: 51;
            display: block;
            background-color: #fff;
            border-bottom: 1px solid var(--primary-border--dark);
        }
    }

    .the-header-main__wrapper {
        @include bp($bp-desktop-sm) {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

    .the-header-main__logo {
        @include bp($bp-desktop-sm) {
            position: relative;
            z-index: 9;
            width: 242px;
        }
    }

    .the-header-main__navigation {
        @include bp($bp-desktop-sm) {
            margin-right: auto;
        }
    }

    .the-header-main__cart {
        @include bp($bp-desktop-sm) {
            margin-left: 24px;
        }
    }
</style>
